<template>
  <div class="manual-text">
    <h1 class="text-center mt-2 mb-10">Quick Editing</h1>

    <p>
      Quick editing is available exclusively on the Show page of a KPI. This feature is designed to assist the users in
      correcting minor errors in weights or values quickly without having to go through the four-step editing form
      saving time and eliminating manual overhead.
    </p>

    <p>
      To quick edit a KPI, <b>double click</b> on any <b>weight</b> or <b>aggregation level score</b>. A small form will
      appear the user will be able to modify the value present on the table.
    </p>

    <div class="image-container">
      <img src="@/images/manual/quick-edit.png" alt="double click 1" />
      <div class="img-caption">
        Figure 1. Example of the double-click action.
      </div>
    </div>

    <p>
      By tapping "Enter" on the keyboard or clicking the <i class="fa fa-check" /> button, the value will be saved and
      the KPI will be updated. Also, an informatory message will appear on the top of the screen.
    </p>

    <p>
      <i class="fas fa-info-circle"/> <b>Important Note!</b> Once the value is edited, there is no undo button. Users
      must make sure that they are 100% certain about the value and the KPI they're modifying. Editing these values
      might affect the flow of the Analysis!
    </p>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>